import React from 'react';
import './styles.css'
import { Parallax } from "react-parallax";
import Contact from '../Contact/Contact'
import MetaTags from 'react-meta-tags';

import { Link } from "react-router-dom";

import Particles from 'react-particles-js';

import image1 from "../../obrazky/titulna_strana/02.jpg";
import image3 from "../../obrazky/titulna_strana/03.jfif";
import image4 from "../../obrazky/titulna_strana/04.jpg";
import image5 from "../../obrazky/titulna_strana/05.jpg";
import image6 from "../../obrazky/titulna_strana/06.jfif";
import image7 from "../../obrazky/titulna_strana/07.jpg";
import image8 from "../../obrazky/titulna_strana/08.jfif";
import image9 from "../../obrazky/titulna_strana/311.jpg";

const insideStyles = {
    position: "absolute",
    top: "50%",
    left: "50%",
    color: "black",
    backgroundColor: 'rgba(255,255,255,0.5)',
    fontSize: "3em",
    fontWeight: '800',
    textTransform: 'uppercase',
    width: "85vw",
    transform: "translate(-50%,-50%)",
};



export default function Home() {
    return (
        <main id="page-wrap">
            <MetaTags>
                <title>Miroslav Babinčák</title>
                <meta name="description" content="Umelecká a reklamná tvorba - 3D nápisy, maľovaná reklama, obrazy, kreslené portréty, airbrush, tetovania, foto a ďalšie..." />
                <meta property="og:title" content="Miroslav Babinčák" />
                <meta name="keywords" content="reklama, babincak, 3d reklama, malovana reklama, portrety, michalovce"/>
            </MetaTags>
            <Particles id="particles-canvas"
                params={{
                    "particles": {
                        "number": {
                            "value": 10,
                            "density": {
                                "enable": true,
                                "value_area": 800
                            }
                        },
                        "line_linked": {
                            "enable": false
                        },
                        "move": {
                            "speed": 1,
                            "out_mode": "out"
                        },
                        "shape": {
                            "type": [
                                "image",    
                            ],
                            "image": [
                                {
                                    "src": "/letters/m.png",
                                    "height": 20,
                                    "width": 23
                                },
                                {
                                    "src": "/letters/i.png",
                                    "height": 20,
                                    "width": 20
                                },
                                {
                                    "src": "/letters/r.png",
                                    "height": 20,
                                    "width": 20
                                },
                                {
                                    "src": "/letters/o.png",
                                    "height": 20,
                                    "width": 20
                                },
                                {
                                    "src": "/letters/b.png",
                                    "height": 20,
                                    "width": 20
                                },
                                {
                                    "src": "/letters/a.png",
                                    "height": 20,
                                    "width": 20
                                },
                                {
                                    "src": "/letters/c.png",
                                    "height": 20,
                                    "width": 20
                                },
                                {
                                    "src": "/letters/n.png",
                                    "height": 20,
                                    "width": 20
                                },
                                {
                                    "src": "/letters/k.png",
                                    "height": 20,
                                    "width": 20
                                },
                            ]
                        },
                        "color": {
                            "value": "#CCC"
                        },
                        "size": {
                            "value": 30,
                            "random": false,
                            "anim": {
                                "enable": true,
                                "speed": 1,
                                "size_min": 10,
                                "sync": false
                            }
                        }
                    },
                    "retina_detect": false}}
                    />
            <h1 className="headline">Umelecká tvorba na jednom mieste</h1>
            <Parallax bgImage={image1} strength={250}>
                <div style={{ height: 600 }}>
                    <div style={insideStyles}>
                        <Link to="/3d-napisy" className={'section-header'}>
                            3D nápisy
                        </Link>
                    </div>
                </div>
            </Parallax>
            <h2 className="section-divider">| | |</h2>
            <Parallax bgImage={image3} strength={-400}>     
                <div style={{ height: 500 }}>
                    <div style={insideStyles}>
                        <Link to="/malovana-reklama" className={'section-header'}>
                            Maľovaná reklama
                        </Link>
                    </div>
                </div>
            </Parallax>
            <h2 className="section-divider">| | |</h2>
            <Parallax bgImage={image8} strength={250}>
                <div style={{ height: 600 }}>
                    <div style={insideStyles}>
                        <Link to="/obrazy" className={'section-header'}>
                            Obrazy
                        </Link>
                    </div>
                </div>
            </Parallax>
            <h2 className="section-divider">| | |</h2>
            <Parallax bgImage={image9} strength={250}>
                <div style={{ height: 600 }}>
                <div style={insideStyles}>
                        <Link to="/kreslene-portrety" className={'section-header'}>
                            Kreslené portréty
                        </Link>
                    </div>
                </div>
            </Parallax>
            <div class="section-divider-parent">
                <h2 className="section-divider">| | |</h2>
                <h2 className="section-divider">| | |</h2>
            </div>
            <div className="section-row">
                <Parallax bgImage={image4} strength={-300} style={{flex: '1'}}>
                    <div style={{ height: 300 }}>
                        <div style={insideStyles}>
                            <Link to="/tetovania" className={'section-header'}>
                                Tetovania
                            </Link>
                        </div>
                    </div>
                </Parallax>
                <Parallax bgImage={image5} strength={-300} style={{flex: '1'}}>
                    <div style={{ height: 300 }}>
                        <div style={insideStyles}>
                            <Link to="/foto" className={'section-header'}>
                                Foto
                            </Link>
                        </div>
                    </div>
                </Parallax>
            </div>
            <div className="section-row-mobile">
                <Parallax bgImage={image4} strength={-300} style={{flex: '1'}}>
                    <div style={{ height: 300 }}>
                        <div style={insideStyles}>
                            <Link to="/tetovania" className={'section-header'}>
                                Tetovania
                            </Link>
                        </div>
                    </div>
                </Parallax>
                <h2 className="section-divider">| | |</h2>
                <Parallax bgImage={image5} strength={-300} style={{flex: '1'}}>
                    <div style={{ height: 300 }}>
                        <div style={insideStyles}>
                            <Link to="/foto" className={'section-header'}>
                                Foto
                            </Link>
                        </div>
                    </div>
                </Parallax>
            </div>
            <div className="section-divider-parent">
                <h2 className="section-divider">| | |</h2>
                <h2 className="section-divider">| | |</h2>
            </div>
            <Parallax bgImage={image6} strength={600}>
                <div style={{ height: 500 }}>
                    <div style={insideStyles}>
                        <Link to="/airbrush" className={'section-header'}>
                            Airbrush
                        </Link>
                    </div>
                </div>
            </Parallax>
            <h2 className="section-divider">| | |</h2>
            <Parallax
                bgImage={image7}
                strength={200}
                renderLayer={(percentage) => (
                    <div>
                        <div
                            style={{
                                position: "absolute",
                                background: `rgba(255, 125, 0, ${
                                    percentage * 1
                                })`,
                                left: "50%",
                                top: "50%",
                                borderRadius: "50%",
                                transform: "translate(-50%,-50%)",
                                width: percentage * 500,
                                height: percentage * 500,
                            }}
                        />
                    </div>
                )}
            >
                <div style={{ height: 500 }}>
                    <Contact />
                </div>
            </Parallax>
            <h2 className="section-divider">| | |</h2>
        </main>
    )
}